
export const reservationStatusDD = [
  { id: 0, name: "All" },
  { id: 1, name: "Confirmed" },
  { id: 2, name: "Modified" },
  { id: 3, name: "No Show" },
  { id: 4, name: "Cancelled" },
  { id: 5, name: "Unconfirmed" },
];

export const reportTypeDD = [
  { id: "bookingDate", name: "Booking Date" },
  { id: "pickupDate", name: "Pickup Date" },
  { id: "returnDate", name: "Return Date" },
];
